import React from 'react'
import { Provider } from 'react-redux'
import { applyMiddleware, compose, createStore } from 'redux'
import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'
import createSagaMiddleware from 'redux-saga'
import { loadI18Next, TLanguages } from 'Service/i18n'

import Router, { TRouterProps } from '../common/router'
import reducers, { TReducers } from '../common/redux/reducers'
import sagas from '../common/redux/sagas'
import Context from 'App/context'
import queryString from 'query-string'

// import { logger } from 'redux-logger'
import userManager, { OidcProvider, loadUser } from 'App/util/UserManager'

// middlewared
const history = createBrowserHistory({})
const sagaMiddleware = createSagaMiddleware()
const routeMiddleware = routerMiddleware(history)
const middlewares = [sagaMiddleware, routeMiddleware]

// if (process.env.NODE_ENV === 'development') {
//   middlewares.push(logger)
// }

export type TAppProps = {
  name: string
  logoBase64: string
  logoMimeType: string
  languages: TLanguages
  router: TRouterProps
  redux?: {
    sagas: any[]
    reducers: TReducers
  }
  showBreadcrumb?: boolean
  hideTenantSwitch?: boolean
}

const HoosuiteContentSourceApp = ({ name, logoBase64, logoMimeType, languages, redux, router, showBreadcrumb = true, hideTenantSwitch = false }: TAppProps) => {
  loadI18Next(languages)

  const store = createStore(
    reducers(history, redux?.reducers),
    compose(applyMiddleware(...middlewares)),
  )

  // OIDC Azure integration
  //loadUser(store, userManager)

  sagaMiddleware.run(sagas, redux?.sagas)

  const params = queryString.parse(window.location.search);

  const extraParams: Record<string, any> = {};
  
  if (typeof params.state === 'string'){
    let stateParts = params.state.split(';')
    extraParams.hootsuiteUserId  = stateParts[0]
    extraParams.hootsuiteTimestamp  = stateParts[1]
    extraParams.hootsuitePlacementId  = stateParts[2]
    extraParams.hootsuiteToken  = stateParts[3]
  } else {
    if (typeof params.uid === 'string'){
      extraParams.hootsuiteUserId  = params.uid;
    }
    if (typeof params.pid === 'string'){
      extraParams.hootsuitePlacementId  = params.pid;
    }
    if (typeof params.ts === 'string'){
      extraParams.hootsuiteTimestamp  = params.ts;
    }
    if (typeof params.token === 'string'){
      extraParams.hootsuiteToken  = params.token;
    }
  }

  return (
    <Provider store={store}>
      <OidcProvider store={store} userManager={userManager}>
        <Context pages={router.pages || []} name={name} logoBase64={logoBase64} logoMimeType={logoMimeType} extraQueryParams={extraParams} extraTokenParams={extraParams} showBreadcrumb={showBreadcrumb} hideTenantSwitch={hideTenantSwitch}>
          <Router history={history} indexUrl={router.indexUrl} pages={router.pages} />
        </Context>
      </OidcProvider>
    </Provider>
  )
}

export default HoosuiteContentSourceApp
